import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ColumnStack from 'libs/ui/layout/stack/column.stack';
import React from 'react';
import { RegisterAsCochlearSpecialistButton } from './cochlear.components';
import { useLocalization } from 'localization/useLocalization';
import { ICochlearSettingsDto } from 'gen/ApiClient';

type CochlearBasicInfoTabProps = {
	settings: ICochlearSettingsDto;
};

export const CochlearBasicInfoTab = ({ settings }: CochlearBasicInfoTabProps) => {
	const strings = useLocalization();

	return (
		<ColumnStack
			dfcol
			w100
			style={{ padding: '16px' }}>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<div className='df-row-ac gap-8'>
						<div style={{ fontWeight: 600 }}>{strings.criteriaOlder18Year}</div>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					<img
						src='https://hamspublicfiles.blob.core.windows.net/cochlear/criteria_more_18y.png'
						alt='criteria > 18y'
						style={{ maxWidth: '90%' }}
					/>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<div className='df-row-ac gap-8'>
						<div style={{ fontWeight: 600 }}>{strings.criteriaYounger18Year}</div>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					<img
						src='https://hamspublicfiles.blob.core.windows.net/cochlear/criteria_less_18y.png'
						alt='criteria < 18y'
						style={{ maxWidth: '90%' }}
					/>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<div className='df-row-ac gap-8'>
						<div style={{ fontWeight: 600 }}>{strings.ciTraject}</div>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					<div>
						<em>{`No content provided yet`}</em>
					</div>
				</AccordionDetails>
			</Accordion>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<div className='df-row-ac gap-8'>
						<div style={{ fontWeight: 600 }}>{strings.specialization}</div>
					</div>
				</AccordionSummary>
				<AccordionDetails>
					<ColumnStack
						dfcol
						style={{ gap: '8px' }}>
						<div
							style={{
								whiteSpace: 'pre-line',
							}}>
							{strings.ciSpecializationContent}
						</div>
						<div>
							<RegisterAsCochlearSpecialistButton settings={settings} />
						</div>
					</ColumnStack>
				</AccordionDetails>
			</Accordion>
		</ColumnStack>
	);
};
